'use strict';

angular.module('systemOwnerUserRequestControllers')

.controller('CardSystemOwnerNetworkShareController', ['$rootScope', '$scope', 'systemOwnerUserRequestService', function ($rootScope, $scope, systemOwnerUserRequestService) {

    // Display actions
    $scope.displayActions = false;

    $scope.showOrHideActions = function ($event) {
        $scope.displayActions = !$scope.displayActions;
        $event.stopPropagation();
    }

    // To Process
    $scope.isToProcess = true;
    $scope.processing = false;
    $scope.statusColor = 'label-green';

    // Approve
    $scope.approve = function (card) {
        $scope.processing = true;

        var userAccessRequestId = card.UserAccessRequest.UserAccessRequestID;
        var firstPending = card.Pendings[0];
        var systemIds = _.chain(card.Pendings)
                         .map('SystemID')
                         .uniq()
                         .value();

        systemOwnerUserRequestService.authorizeUserRequestSystems(userAccessRequestId, systemIds)
        .then(function (response) {
            if (!_.isUndefined(response.GrowlMessages)) return;

            $scope.isToProcess = false;
            $scope.statusCard = 'Approved'
            $scope.processing = false;
            card.isToProcess = false;

            $rootScope.$broadcast('systemowner-userrequest-approve-reject');
        });
    }

    // Reject
    $scope.reject = function (card) {
    }

    // When approve all
    $scope.$on('systemowner-userrequest-approve-all', function (event, args) {
        if (!_.isUndefined($scope.statusCard)) return;
        $scope.approve($scope.card);
    });
}]);